import React,{useReducer,useEffect} from 'react';
import { BrowserRouter,Routes,Route,Navigate } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import { authReducer } from '../auth/authReducer';
import { Home } from '../Components/Home/Home';
import { HomeCaja } from '../Components/Home/Caja';
import { HomeFinanzas } from '../Components/Home/Finanzas';
import { HomeProcesos } from '../Components/Home/Procesos';
import Cobranza from '../Components/Cobranza/Conbranza';
import { Navbar } from '../Components/Navbar/Navbar';
import { Login } from '../views/Login/Login';
import { NuevaCotizacion } from '../Components/NuevaCotizacion/NuevaCotizacion';
import { ThemeProvider } from 'react-jss';
import { useSelector, useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import { setStateGlobal, showAlert } from '../reducers/appReducer';
import { Directorio } from '../Components/Directorio/Directorio';
import socketIOClient from "socket.io-client";
import Redirect from '../utils/redirect';
import Vendedores from '../Components/Vendedores/Vendedores';
import { EditarTramite } from '../Components/EditarTramite/EditarTramite';

const init = () => {
    const dataStorage = JSON.parse(localStorage.getItem("userInterBrokers"));
    if (!dataStorage) return { logged: false };
    // const today = new Date();
    // const year = today.getFullYear();
    // const month = ("0" + (today.getMonth() + 1)).slice(-2);
    // const day = ("0" + today.getDate()).slice(-2);
    // if (dataStorage.date_login !== `${year}-${month}-${day}`)
    //   return { logged: false };
    return JSON.parse(localStorage.getItem("userInterBrokers"));
};

const ProtectedRoute = ({
    usuario,
    redirectPath = "/login",
    children,
}) => {
    if(!usuario.logged){
        return <Navigate to={redirectPath} replace />
    }
    return children;
}

export const DashboardRoutes = ({initData}) => {

    const globalState = useSelector( (state) => state.agents );
    const dispatchGlobal = useDispatch();
    const { toastAlert, logged } = globalState;
    const[usuario,dispatch] = useReducer(authReducer,{},init);
    const theme = {
        // colorPrimary: initData.background_primario
        colorPrimary: '#f4244c'
    }

    useEffect(() => {
        fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getListTramite',{
            method: 'POST',
            mode: 'cors',
        })
        .then( response => response.json() )
        .then( response => {
            dispatchGlobal( setStateGlobal({ arrTramites : response.data }) )
        })
    },[])

    useEffect(() => {
        localStorage.setItem("userInterBrokers", JSON.stringify(usuario));
    }, [usuario]);
    
    useEffect(() => {
        if(toastAlert.show){
            toast[toastAlert.type]( (e) => (
                <p className="mb-0">{toastAlert.message}</p>
            ),{
            duration: 2000
            });
            dispatchGlobal( showAlert( { 
                show: false, 
                message: ''
            } ) )
        }
    },[toastAlert.show]);

    useEffect(() => {
        // getConnectionSocket()
        socket.on("connect", (_) => {     
        })
        socket.on("__cajeroReceive", (server) => {
            window.location.reload()
        });
    },[]);

    if(initData.background_primario===undefined) return false;

    const socket = socketIOClient("https://wsoft.com.mx:3011")

    // console.log('hay', usuario)
    return (
        <React.Fragment>
            <AuthContext.Provider value={{ usuario,dispatch }}>
                <ThemeProvider theme={theme}>
                    <BrowserRouter>

                        <Routes>
                            <Route path="/login" element={<Login />} />

                            <Route path="/"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} typeView={'home'} />
                                    <Home typeView={'home'} socket={socket} />
                                </ProtectedRoute>
                            }
                            />

                            <Route path="/directorio"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <Directorio socket={socket} />
                                </ProtectedRoute>
                            }
                            />

                            <Route 
                            path="/homeCaja"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} typeView={'homeCaja'} />
                                    <HomeCaja typeView={'homeCaja'} socket={socket} />
                                </ProtectedRoute>
                            }
                            />

                            <Route 
                            path="/homeFinanzas"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} typeView={'homeFinanzas'} />
                                    <HomeFinanzas typeView={'homeFinanzas'} socket={socket} />
                                </ProtectedRoute>
                            }
                            />
                            
                            <Route 
                            path="/homeProcesos"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} typeView={'homeProcesos'} />
                                    <HomeProcesos typeView={'homeProcesos'} socket={socket} />
                                </ProtectedRoute>
                            }
                            />

                            <Route
                            path="/nuevaCotizacion"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <NuevaCotizacion socket={socket} usuario={usuario} />
                                    {/* <HomeProcesos /> */}
                                </ProtectedRoute>
                            }
                            />

                            <Route
                            path="/editartramites"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <EditarTramite socket={socket} /> 
                                    {/* <HomeProcesos /> */}
                                </ProtectedRoute>
                            }
                            />

                            <Route 
                            path="/cobranza"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <Cobranza socket={socket} />
                                </ProtectedRoute>
                            }
                            />

                            <Route 
                            path="/vendedores"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <Vendedores typeView={'vendedores'} socket={socket} />
                                </ProtectedRoute>
                            }
                            />

                        </Routes>

                    </BrowserRouter>
                </ThemeProvider>
            </AuthContext.Provider>
        </React.Fragment>
    )
}
